// MergedChildCellRenderer.tsx
import React from "react";
import { MergedChild } from "../../models/Po";

interface MergedChildCellRendererProps {
  value: MergedChild[];
  valueFormatted: string;
  context: {
    openMergedChildModal: (mergedChildren: MergedChild[]) => void;
  };
}

const MergedChildCellRenderer: React.FC<MergedChildCellRendererProps> = ({
  value,
  valueFormatted,
  context,
}) => {
  const handleClick = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.stopPropagation();
    event.preventDefault();
    context.openMergedChildModal(value);
  };

  const allReady = value?.every((child: MergedChild) => {
    const maxMachSeqProgress = child.progresses?.reduce(
      (max: any, progress: any) =>
        progress.mach_seq > max.mach_seq ? progress : max,
      { mach_seq: -1, status: 0 }
    );
    return maxMachSeqProgress?.status === 4;
  });

  const displayText = allReady ? "準備完了" : "前工程未完了";
  const displayColor = allReady ? "green" : "red";
  const hoverColor = allReady ? "darkgreen" : "darkred";

  if (value && value.length > 0) {
    return (
      <span
        className="merged-child-link"
        style={{
          cursor: "pointer",
          textDecoration: "underline",
          color: displayColor,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.color = hoverColor;
          e.currentTarget.style.textDecoration = "underline";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.color = displayColor;
          e.currentTarget.style.textDecoration = "underline";
        }}
        onClick={handleClick}
      >
        <i className="fa fa-sitemap"></i> {displayText}
      </span>
    );
  }
  return null;
};

export default MergedChildCellRenderer;
